export const PAGE_TITLE = 'Unit'
export const BACK_LINK_DIGITAL_WELL_BEING = 'Digital Well-Being Lessons'
export const BACK_LINK_ELEMENTARY_LESSONS = 'Elementary Lessons'
export const BACK_LINK_MIDDLE_SCHOOL_LESSONS = 'Middle School Lessons'
export const BACK_LINK_LABEL_BY_PRODUCT = {
  'digital-well-being': BACK_LINK_DIGITAL_WELL_BEING,
  elementary: BACK_LINK_ELEMENTARY_LESSONS,
  'middle-school': BACK_LINK_MIDDLE_SCHOOL_LESSONS,
}
export const TEACHING_THE_UNIT_ROUTE_PREFIX = 'teaching-the-unit'
